var _circle, _path, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47.5,
    fill: "white",
    stroke: "#ED5272"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4788 49.3317C69.6744 49.3317 68.1364 48.6817 66.8646 47.3817C65.5929 46.0817 64.957 44.5095 64.957 42.665C64.957 41.5984 65.1853 40.6039 65.6418 39.6817C66.0983 38.7595 66.7396 37.9762 67.5657 37.3317V26.665C67.5657 25.5539 67.9462 24.6095 68.707 23.8317C69.4679 23.0539 70.3918 22.665 71.4788 22.665C72.5657 22.665 73.4896 23.0539 74.2505 23.8317C75.0114 24.6095 75.3918 25.5539 75.3918 26.665V37.3317C76.2179 37.9762 76.8592 38.7595 77.3157 39.6817C77.7722 40.6039 78.0005 41.5984 78.0005 42.665C78.0005 44.5095 77.3646 46.0817 76.0929 47.3817C74.8211 48.6817 73.2831 49.3317 71.4788 49.3317ZM70.1744 34.665H72.7831V33.3317H71.4788V31.9984H72.7831V29.3317H71.4788V27.9984H72.7831V26.665C72.7831 26.2873 72.6581 25.9706 72.4081 25.715C72.1581 25.4595 71.8483 25.3317 71.4788 25.3317C71.1092 25.3317 70.7994 25.4595 70.5494 25.715C70.2994 25.9706 70.1744 26.2873 70.1744 26.665V34.665Z",
    fill: "#ED5272"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_652_1338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 20,
    width: 55,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 20,
    width: 54.7825,
    height: 56,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_652_1338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1694 68.999C23.7509 68.999 23.3704 68.8921 23.028 68.6782C22.6857 68.4643 22.4194 68.1824 22.2291 67.8324C22.0389 67.4824 21.9343 67.1032 21.9153 66.6949C21.8963 66.2865 22.0009 65.8879 22.2291 65.499L43.3432 28.1657C43.5715 27.7768 43.8663 27.4851 44.2277 27.2907C44.5891 27.0962 44.9601 26.999 45.3405 26.999C45.7209 26.999 46.0919 27.0962 46.4533 27.2907C46.8147 27.4851 47.1095 27.7768 47.3378 28.1657L68.4519 65.499C68.6801 65.8879 68.7847 66.2865 68.7657 66.6949C68.7467 67.1032 68.6421 67.4824 68.4519 67.8324C68.2616 68.1824 67.9953 68.4643 67.6529 68.6782C67.3106 68.8921 66.9301 68.999 66.5116 68.999H24.1694ZM28.1068 64.3324H62.5742L45.3405 33.999L28.1068 64.3324ZM45.3405 61.999C45.9872 61.999 46.5294 61.7754 46.9669 61.3282C47.4044 60.881 47.6231 60.3268 47.6231 59.6657C47.6231 59.0046 47.4044 58.4504 46.9669 58.0032C46.5294 57.556 45.9872 57.3324 45.3405 57.3324C44.6938 57.3324 44.1516 57.556 43.7141 58.0032C43.2766 58.4504 43.0579 59.0046 43.0579 59.6657C43.0579 60.3268 43.2766 60.881 43.7141 61.3282C44.1516 61.7754 44.6938 61.999 45.3405 61.999ZM45.3405 54.999C45.9872 54.999 46.5294 54.7754 46.9669 54.3282C47.4044 53.881 47.6231 53.3268 47.6231 52.6657V45.6657C47.6231 45.0046 47.4044 44.4504 46.9669 44.0032C46.5294 43.556 45.9872 43.3324 45.3405 43.3324C44.6938 43.3324 44.1516 43.556 43.7141 44.0032C43.2766 44.4504 43.0579 45.0046 43.0579 45.6657V52.6657C43.0579 53.3268 43.2766 53.881 43.7141 54.3282C44.1516 54.7754 44.6938 54.999 45.3405 54.999Z",
    fill: "#ED5272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/Temp.090bb249695164ab46bd54e6133a24b0.svg";
export { ForwardRef as ReactComponent };